/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Images_TitleInputs */

const cs_property_ai_images_title = /** @type {(inputs: Property_Ai_Images_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI fotek`)
};

const en_property_ai_images_title = /** @type {(inputs: Property_Ai_Images_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photo AI`)
};

/**
* | output |
* | --- |
* | "Photo AI" |
*
* @param {Property_Ai_Images_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_images_title = /** @type {((inputs?: Property_Ai_Images_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Images_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_images_title(inputs)
	return cs_property_ai_images_title(inputs)
});